export enum ScrollAreaEnum {
  Grid = "Grid",
  GridGrouped = "GridGrouped",
  BookingsCalendar = "BookingsCalendar",
  RidesCalendar = "RidesCalendar",
  CoursesCalendar = "CoursesCalendar",
  RidesKanbanColumnLow = "RidesKanbanColumnLow",
  RidesKanbanColumnMedium = "RidesKanbanColumnMedium",
  RidesKanbanColumnHigh = "RidesKanbanColumnHigh",
}
